import { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { MdNotificationsNone, MdNotificationsActive } from "react-icons/md"
import { toast } from "react-toastify";
import { handleInterest } from "../../services/interest.service";
import InterestFeeback from "./components/interest-feedback";
import { CustomButton } from "./styles"

interface IButtonInterest {
    interesting?: boolean;
    id: number;
    color?: string;
}

export const ButtonInterest: React.FC<IButtonInterest> = ({ interesting = false, id, color = "#606060" }) => {
    const [hasInterest, setHasInterest] = useState<boolean>(interesting)

    const activeInterest = () => {
        
        handleInterest(id).then(() => {
            toast.success(<InterestFeeback mode="activated" /> , {
                autoClose: 15000,
                icon: false,
                pauseOnFocusLoss: false,
                style: { width: 385, right: 60, backgroundColor: '#20A85D'}
            })
            setHasInterest(true)
        }).catch((err) => {
            toast.error(err.response.data[0]);
        })
    }

    const deactivateInterest = () => {
        
        handleInterest(id).then(() => {
            toast.success(<InterestFeeback mode="deactivated" /> , {
                autoClose: 15000,
                icon: false,
                pauseOnFocusLoss: false,
                style: { width: 385, right: 60, backgroundColor: '#20A85D'}
            })
            setHasInterest(false)
        }).catch((err) => {
            toast.error(err.response.data[0]);
        })
    }


    if (hasInterest) {
        return (
            <OverlayTrigger
                placement={'left'}
                overlay={<Tooltip >Você será avisado quando o
                    material estiver disponível</Tooltip>}
            >
                <CustomButton onClick={deactivateInterest} type="button">
                    <MdNotificationsActive color={color} size={22} />
                </CustomButton>

            </OverlayTrigger>
        )

    } else {
        return (
            <OverlayTrigger
                placement={'left'}
                overlay={<Tooltip >Avise-me quando o material estiver disponível</Tooltip>}
            >
                <CustomButton onClick={activeInterest} type="button">
                    <MdNotificationsNone color={color} size={24} />
                </CustomButton>

            </OverlayTrigger>
        )
    }



}